import type { ReactNode } from "react";
import { flattenMessages, LocaleBootstrapper, useLocaleCopyStore, useLocaleStore } from "@akina/presentation";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { loggerService } from "@akina/infra";
import { careEnvironment } from "@akina/config";

type IntlProviderProps = Readonly<{
    children: ReactNode;
}>;

export function IntlProvider({ children }: IntlProviderProps) {
    const { locale } = useLocaleStore();
    const { localeCopy } = useLocaleCopyStore();
    const messages = flattenMessages(localeCopy);

    return (
        <ReactIntlProvider onError={handleIntlError} locale={locale} messages={messages}>
            <LocaleBootstrapper slugPrefixes={["care", "shared"]} />
            {children}
        </ReactIntlProvider>
    );
}

function handleIntlError(err: { code: string; message: string }) {
    if (err.code === "MISSING_TRANSLATION" || err.code === "MISSING_DATA") return;
    if (careEnvironment.environment !== "prod") {
        loggerService.warn("[IntlProvider]", err.message);
    }
}
